import { FC } from 'react';
import {
  Datagrid,
  List,
  TextField,
  DateField,
  CreateButton,
  TopToolbar,
} from 'react-admin';
import { TemperatureField } from '../../../../entities/TemperatureField/ui/TemperatureField';
import { ReuseButton } from '../../../../entities/ReuseButton/ui/ReuseButton';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Создать промпт" />
  </TopToolbar>
);

export const PromptList: FC = () => (
  <List title="Промпт" filter={{}} actions={<ListActions />}>
    <Datagrid isRowSelectable={() => false}>
      <TextField source="id" label="ID" />
      <TextField source="prompt" label="Промпт" />
      <TextField source="username" label="Автор" />
      <TemperatureField source="temperature" label="Температура" />
      <DateField source="created_at" locales={['ru']} label="Дата создания" />
      <ReuseButton />
    </Datagrid>
  </List>
);
